export const getDefaultProjectCurrency = projectCurrencies => {
  if (projectCurrencies) {
    return projectCurrencies?.find(
      projectCurrency => projectCurrency.isDefault
    );
  }
  return null;
};
